import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@shadcn-in-nx/ui/button";
import { Checkbox } from "@shadcn-in-nx/ui/checkbox";
import { Label } from "@shadcn-in-nx/ui/label";
import { Loader2, Archive } from "lucide-react";

export default function BulkActionsBar({ tickets, selectedTickets, toggleSelectAll, onBulkArchive, isArchiving }) {
    const { t } = useTranslation();

    if (tickets.length === 0) return null;

    return (
        <div className="flex items-center gap-4">
            <Checkbox
                checked={selectedTickets.size === tickets.length && tickets.length > 0}
                onCheckedChange={toggleSelectAll}
            />
            <Label className="text-sm cursor-pointer" onClick={toggleSelectAll}>
                {t("admin.support.selectAll", "Select All")}
            </Label>
            {selectedTickets.size > 0 && (
                <Button variant="outline" size="sm" onClick={onBulkArchive} disabled={isArchiving}>
                    {isArchiving ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Archive className="w-4 h-4 mr-1" />}
                    {t("admin.support.archiveSelected", "Archive Selected ({{count}})", { count: selectedTickets.size })}
                </Button>
            )}
        </div>
    );
}
